import { styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { useEffect, useRef, useState } from 'react'

export const ElapsedImportTime = () => {
    const startedAt = useRef(Date.now())
    const [elapsedSeconds, setElapsedSeconds] = useState(0)

    useEffect(() => {
        const interval = window.setInterval(() => {
            setElapsedSeconds(Math.floor((Date.now() - startedAt.current) / 1000))
        }, 1000)
        return () => window.clearInterval(interval)
    }, [])

    const elapsedTime = `${String(Math.floor(elapsedSeconds / 60)).padStart(2, '0')}:${String(elapsedSeconds % 60).padStart(2, '0')}`

    return (
        <Timer role="timer" aria-label={`Vergangene Zeit ${elapsedTime}`}>
            <Typography variant="textS" color={tokens.ColorTextSubtle}>
                {elapsedTime}
            </Typography>
        </Timer>
    )
}

const Timer = styled('div')(() => ({
    flexShrink: 0,
    fontVariantNumeric: 'tabular-nums',
}))
